<template>
  <!--eslint-disable-->
  <ValidationObserver v-slot="{ handleSubmit }" ref="form" id="edutalkCustomerForm">
    <form class="form customer-form" id="customer_create" @submit.prevent="handleSubmit(saveCustomer)">
      <div @click="dialogFilterForm = true" class="cursor-pointer d-flex justify-content-end align-items-center mb-2" style="color:rgba(0, 0, 0, 1)">
        <i class="el-icon-setting"></i>
        <span class="ml-1">Cài đặt hiển thị</span>
      </div>
      <div class="row mb-3">
        <div class="col-md-4">
          <div class="card card-custom gutter-b example example-compact border border-success mb-3"
               v-if="filterOption?.basic.length > 0">
            <div class="card-header bg-success">
              <h3 class="card-title  text-white">Thông tin cơ bản</h3>
            </div>

            <!--begin::Form-->
            <div class="card-body">
              <div class="row">
                <div class="col-md-6" v-if="filterOption?.basic.includes('phone')">
                  <div class="form-group">
                    <label class="form-label">Số điện thoại <span class="text-danger">*</span></label>
                    <ValidationProvider vid="phone" name="Số điện thoại"
                                        :rules="{ required: true,regex: /^(0[3|5|7|8|9])+([0-9]{8})$/ }"
                                        v-slot="{ errors,classes }">
                      <input type="number" :class="classes" class="form-control"
                             v-model="customer.phone"
                             placeholder="Số điện thoại"
                             :disabled="check_edit"
                      >
                      <div class="fv-plugins-message-container">
                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                          {{ errors[0] }}
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-md-6 mb-3" v-if="filterOption?.basic.includes('name')">
                  <div class="form-group">
                    <label class="form-label">Họ tên <span class="text-danger">*</span></label>
                    <ValidationProvider vid="name" name="Họ tên" rules="required"
                                        v-slot="{ errors,classes }">
                      <input type="text" class="form-control" placeholder="Họ tên"
                             :disabled=" is_personal"
                             v-model="customer.name" :class="classes">
                      <div class="fv-plugins-message-container">
                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                          {{ errors[0] }}
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-md-6 mb-3" v-if="filterOption?.basic.includes('email')">
                  <div class="form-group">
                    <label class="form-label">Email</label>
                    <input type="email" class="form-control" placeholder="Email"
                           v-model="customer.email"
                           :disabled="check_edit || is_personal"
                    >
                  </div>
                </div>
                <div class="col-md-6" v-if="filterOption?.basic.includes('facebook')">
                  <div class="form-group">
                    <label class="form-label">Facebook<span class="text-danger"></span></label>
                    <input type="text" class="form-control" placeholder="Facebook" v-model="customer.link_fb">
                  </div>
                </div>
                <div class="col-md-6 mb-3" v-if="filterOption?.basic.includes('birthday')">
                  <div class="form-group">
                    <label class="form-label">Ngày sinh <span class="text-danger"> *</span></label>
                      <ValidationProvider vid="ngay_sinh" name="Ngày sinh" rules="required" v-slot="{ errors }">
                          <el-date-picker
                              ref="birthdayPicker"
                              class="customer-birthday"
                              v-model="customer.ngay_sinh"
                              type="date"
                              value-format="yyyy-MM-dd"
                              format="dd/MM/yyyy"
                              placeholder="00/00/0000"
                              :editable="true"
                              :clearable="true"
                              @focus="bindBirthdayMask"
                          />
                          <div class="fv-plugins-message-container">
                              <div class="fv-help-block">{{ errors[0] }}</div>
                          </div>
                      </ValidationProvider>
                  </div>
                </div>
                <div class="col-md-6" v-if="filterOption?.basic.includes('que_quan')">
                  <div class="form-group">
                    <label class="form-label">Quê quán<span class="text-danger"></span></label>
                    <input type="text" class="form-control" placeholder="Quê quán" v-model="customer.que_quan">
                  </div>
                </div>
                <div class="col-md-6" v-if="filterOption?.basic.includes('province_id')">
                  <div class="form-group">
                    <label class="form-label">Tỉnh, thành phố<span class="text-danger">*</span></label>
                    <ValidationProvider
                      vid="province_id"
                      name="Tỉnh, thành phố"
                      :rules="'required'"
                      v-slot="{ errors }"
                    >
                      <el-select
                        filterable
                        v-model="customer.province_id"
                        placeholder="Tỉnh, thành phố"
                        clearable
                        @input="changeDistricts"
                      >
                        <el-option
                          v-for="item in provinces"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <div class="fv-plugins-message-container">
                        <div data-field="province_id" data-validator="notEmpty" class="fv-help-block">
                          {{ errors[0] }}
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="col-md-6" v-if="filterOption?.basic.includes('district_id')">
                  <div class="form-group">
                    <label class="form-label">Xã, phường <span class="text-danger">*</span></label>
                      <ValidationProvider
                          vid="district_id"
                          name="Xã, phường"
                          :rules="customer.province_id ? 'required' : ''"
                          v-slot="{ errors }"
                      >
                        <el-select
                          filterable
                          :disabled="!customer.province_id"
                          v-model="customer.district_id"
                          placeholder="Xã, phường"
                          clearable
                        >
                          <el-option
                            v-for="item in districts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                        <div class="fv-plugins-message-container">
                          <div data-field="province_id" data-validator="notEmpty" class="fv-help-block">
                            {{ errors[0] }}
                          </div>
                        </div>
                      </ValidationProvider>
                  </div>
                </div>

                <div class="col-md-12" v-if="filterOption?.basic.includes('sub_district')">
                  <div class="form-group">
                    <label class="form-label">Số nhà, đường<span class="text-danger"></span></label>
                    <input type="text" class="form-control" placeholder="Nhập địa chỉ chi tiết" v-model="customer.sub_district">
                    <span style="margin-top: 5px">Lưu ý: Thông tin này được sử dụng để gửi quà, box, sách cho khách hàng. Vui lòng nhập chính xác.</span>
                  </div>
                </div>

                <div class="col-md-6" v-if="filterOption?.basic.includes('school')">
                  <div class="form-group">
                    <label class="form-label">Trường học
                      <span class="text-danger" v-if="isRequireSchool || checkSchoolAffiliation">*</span>
                    </label>
                    <ValidationProvider
                        vid="co_quan"
                        name="Trường học"
                        :rules="isRequireSchool || checkSchoolAffiliation  ? 'required' : ''"
                        v-slot="{ errors }"
                    >
                        <el-select
                            ref="schoolSelect"
                            v-model="customer.co_quan"
                            clearable
                            class="w-100"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="Trường học"
                            popper-class="customer-school-select-dropdown"
                            :remote-method="searchSchoolList"
                            @clear="clearSchoolSearch"
                            @visible-change="handleSchoolSelectVisible"
                        >
                            <el-option
                                v-for="item in schoolList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                      <div class="fv-plugins-message-container">
                        <div data-field="co_quan" data-validator="notEmpty" class="fv-help-block">
                          {{ errors[0] }}
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="col-md-6 mb-3" v-if="filterOption?.basic.includes('major')">
                  <div class="form-group">
                    <label class="form-label">Ngành học<span class="text-danger"></span></label>
                    <input type="text" class="form-control" placeholder="Ngành học" v-model="customer.nganh">
                  </div>
                </div>

                <div class="col-md-6 mb-3" v-if="filterOption.basic.includes('object_customer')">
                  <div class="form-group mb-1">
                    <label class="form-label">Đối tượng<span class="text-danger"> *</span></label>
                    <ValidationProvider vid="object_customer" name="Đối tượng" rules="required"
                                        v-slot="{ errors }">
                      <el-select v-model="customer.object_customer" clearable class="w-100" placeholder="Chọn đối tượng">
                        <el-option
                            v-for="item in objectCustomerDefine"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id">
                          <span style="float: left">{{ item.value }}</span>
                        </el-option>
                      </el-select>
                      <div class="fv-plugins-message-container">
                        <div data-field="object_customer" data-validator="notEmpty" class="fv-help-block">
                          {{ errors[0] }}
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
            <!--end::Form-->
          </div>
          <div class="card card-custom gutter-b example example-compact border border-warning mt-4"
               v-if="filterOption.parent.length > 0">
            <div class="card-header bg-warning">
              <h3 class="card-title text-white">Thông tin phụ huynh</h3>
            </div>
            <!--begin::Form-->
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3" v-if="filterOption.parent.includes('name')">
                  <div class="form-group">
                    <label class="form-label">Họ tên<span class="text-danger"></span></label>
                    <input type="text" class="form-control" v-model="customer.bo_me" placeholder="Họ tên">
                  </div>
                </div>
                  <div class="col-md-12 mb-3" v-if="filterOption.parent.includes('phone')">
                      <div class="form-group">
                          <label class="form-label">
                              Số điện thoại<span class="text-danger"></span>
                          </label>
                          <ValidationProvider
                              vid="parent_phone"
                              name="Số điện thoại"
                              :rules="{ regex: /^(0[3|5|7|8|9])+([0-9]{8})$/ }"
                              v-slot="{ errors, classes }"
                          >
                              <input
                                  type="tel"
                                  :class="classes"
                                  class="form-control"
                                  v-model="customer.sdt_phu_huynh"
                                  placeholder="Số điện thoại"
                              >
                              <div class="fv-plugins-message-container">
                                  <div class="fv-help-block">
                                      {{ errors[0] }}
                                  </div>
                              </div>
                          </ValidationProvider>
                      </div>
                  </div>

                  <div class="col-md-12 mb-3" v-if="filterOption.parent.includes('phone_other')">
                      <div class="form-group">
                          <label class="form-label">
                              Số điện thoại người giám hộ khác (Nếu có)
                          </label>
                          <ValidationProvider
                              vid="guardian_phone"
                              name="Số điện thoại khác"
                              :rules="{
                                    regex: /^(0[3|5|7|8|9])+([0-9]{8})$/,
                                    different_phone: customer.sdt_phu_huynh
                                }"
                              v-slot="{ errors, classes }"
                          >
                              <input
                                  type="tel"
                                  :class="classes"
                                  class="form-control"
                                  v-model="customer.phone_other"
                                  placeholder="Số điện thoại khác"
                              >
                              <div class="fv-plugins-message-container">
                                  <div class="fv-help-block">
                                      {{ errors[0] }}
                                  </div>
                              </div>
                          </ValidationProvider>
                      </div>
                  </div>
                <div class="col-md-12 mb-3" v-if="filterOption.parent.includes('origin')">
                  <div class="form-group">
                    <label class="form-label">Quê quán<span class="text-danger"></span></label>
                    <input type="text" class="form-control" placeholder="Quê quán"
                           v-model="customer.que_quan_phu_huynh">
                  </div>
                </div>
                <div class="col-md-12 mb-3" v-if="filterOption.parent.includes('job')">
                  <div class="form-group">
                    <label class="form-label">Nghề nghiệp<span class="text-danger"></span></label>
                    <input type="text" class="form-control" placeholder="Nghề nghiệp"
                           v-model="customer.nghe_nghiep_phu_huynh">
                  </div>
                </div>
                <div class="col-md-12" v-if="filterOption.parent.includes('opinion')">
                  <div class="form-group">
                    <label class="form-label">Ý kiến<span class="text-danger"></span></label>
                    <el-select v-model="customer.y_kien_phu_huynh" clearable class="w-100" placeholder="Chọn ý kiến">
                      <el-option
                          v-for="item in yKien"
                          :key="item.id"
                          :label="item.value"
                          :value="item.id">
                        <span style="float: left">{{ item.value }}</span>
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <!--end::Form-->
          </div>
        </div>
        <div class="col-md-4" v-if="filterOption.potential.length > 0">
          <div class="card card-custom gutter-b example example-compact border border-primary">
            <div class="card-header bg-primary">
              <h3 class="card-title text-white">Thông tin khách hàng tiềm năng
              </h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3" v-if="filterOption.potential.includes('source')">
                  <div class="form-group">
                    <label class="form-label">Kênh<span class="text-danger"> *</span></label>
                    <ValidationProvider vid="nguon" name="Kênh"
                                        rules="required"
                                        v-slot="{ errors }">
                      <el-select @change="changeSource()" v-if="!check_re_register" :disabled="customer.nguon == 'Tái đăng ký'" v-model="customer.nguon" clearable class="w-100" placeholder="Chọn kênh">
                        <el-option
                            v-for="item in nguon"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id">
                          <span style="float: left">{{ item.value }}</span>
                        </el-option>
                      </el-select>
                      <el-input v-else disabled value="Tái đăng ký"></el-input>
                      <div class="fv-plugins-message-container">
                        <div data-field="nguon" data-validator="notEmpty" class="fv-help-block">
                          {{ errors[0] }}
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="col-md-6 mb-3" v-if="filterOption.potential.includes('hotkey')">
                  <div class="form-group mb-1">
                    <label class="form-label">Phím nóng <span class="text-danger">*</span></label>
                    <ValidationProvider vid="phim_nong" name="Phím nóng"
                                        rules="required"
                                        v-slot="{ errors }">
                      <el-select v-model="customer.hot_key" clearable class="w-100" placeholder="Chọn phím nóng" multiple collapse-tags>
                        <el-option
                            v-for="item in phimNongDeFine"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id">
                          <span style="float: left">{{ item.value }}</span>
                        </el-option>
                      </el-select>
                      <div class="fv-plugins-message-container">
                        <div data-field="phim_nong" data-validator="notEmpty" class="fv-help-block">
                          {{ errors[0] }}
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="col-md-12 mb-3" v-for="id in customer.hot_key" :key="id">
                  <div class="form-group mb-1">
                    <label class="form-label">Chi tiết: {{ getHotKeyLabel(id) }} <span class="text-danger"> *</span></label>
                    <div
                        v-if="!customer.hot_key_detail[id]"
                        class="position-absolute text-muted px-2"
                        style="pointer-events: none; top: 30px; left: 12px; white-space: pre-line; line-height: 1.8;">
                      {{ getHotKeyPlaceholder(id) }}
                    </div>
                    <textarea
                        class="form-control"
                        rows="5"
                        v-model="customer.hot_key_detail[id]"
                    >
                    </textarea>
                    <span class="text-danger" v-if="submitHotKeyDetail && (!customer.hot_key_detail[id] || !customer.hot_key_detail[id].trim())">
                          Vui lòng nhập chi tiết
                      </span>
                  </div>
                </div>

                <div class="col-md-12 mb-3" v-if="filterOption.potential.includes('solution')">
                  <div class="form-group mb-1">
                    <label class="form-label">Giải pháp mời hẹn</label>
                    <textarea class="form-control" rows="3" v-model="customer.giai_phap_moi_hen"
                              placeholder="Giải pháp mời hẹn của cấp trên"></textarea>
                  </div>
                </div>
                <div class="col-md-12 mb-3" v-if="filterOption.potential.includes('note')">
                  <div class="form-group mb-1">
                    <label class="form-label">Ghi chú</label>
                    <textarea class="form-control" rows="3" placeholder="Ghi chú" v-model="customer.note"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4" v-if="!checkEdit">
          <div class="card card-custom gutter-b example example-compact border border-info mb-3">
            <div class="card-header bg-info">
              <h3 class="card-title text-white">Đặt lịch tư vấn</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <dat-lich-tu-van
                      :show-info-customer="true" :createScheduleAdvice="customer_id" @changeButtonSave="handleScheduleAdvice"
                      @completed="handleScheduleAdviceCompleted"
                  ></dat-lich-tu-van>
                </div>
              </div>
            </div>
          </div>
          <div class="card card-custom gutter-b example example-compact border border-danger"
               v-if="filterOption.parent.length > 0">
            <div class="card-header bg-danger">
              <h3 class="card-title text-white">Đặt lịch test đầu vào</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <!-- OLD: non-pilot -->
                  <ValidationObserver v-if="!isPilotEntrance" ref="form" v-slot="{ handleSubmit }">
                    <form class="form appointment-form" @submit.prevent="handleSubmit(createScheduleTestInput)" autocomplete="off">
                      <el-row :gutter="10" class="pr-2 pl-2">
                        <option-create-test-input :resetData="true" :isCreateCustomer="true" :createScheduleAdvice="customer_id" @changeButtonSave="handleScheduleAdvice" v-if="statusCreateTestInput === STATUS_CHOOSE_OPTION" @confirmOption="confirmOption"></option-create-test-input>
                        <reschedule-test-input
                            @close="statusCreateTestInput = STATUS_CHOOSE_OPTION"
                            :isCreateCustomer="true"
                            v-if="statusCreateTestInput === STATUS_CREATE"
                            :showTestInput="true"
                            :show-learning-fields="true"
                            @infoTestInput="handleInfoTestInput"
                        >
                        </reschedule-test-input>
                        <LoadingCreateTestInput v-if="statusCreateTestInput === STATUS_PENDING" :idTaskCreating ="idTaskCreating" @statusCreateTestInput="handleStatusCreateTestInput"
                                                :countTime="countTime"></LoadingCreateTestInput>
                        <succes-create-input v-if="statusCreateTestInput === STATUS_TO_DO" :idCustomer="idCustomer || customer_id" :successCreateData="successCreateData"></succes-create-input>
                        <cancel-create-input v-if="statusCreateTestInput === STATUS_FAlURE"></cancel-create-input>
                        <overload-create-test-input v-if="statusCreateTestInput === STATUS_OVER_LOADING"></overload-create-test-input>
                      </el-row>
                      <div class="form-row" v-if="statusCreateTestInput === STATUS_CREATE">
                        <div class="col-md-12 mb-3">
                          <button type="button" class="btn btn-secondary float-right mt-3 ml-3"
                                  @click="statusCreateTestInput = STATUS_CHOOSE_OPTION">
                            Hủy bỏ
                          </button>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                  <!-- NEW: thí điểm -->
                  <transition name="entrance-fade-slide">
                    <schedule-entrance-test-dialog
                      v-if="isPilotEntrance && showEntranceScheduleFlow"
                      embedded
                      :visible="true"
                      :is-create-customer="true"
                      @schedule-change="handleEntranceScheduleChange"
                      @cancel="resetEntranceScheduleFlow"
                    />
                  </transition>
                  <template v-if="isPilotEntrance">
                    <LoadingCreateTestInput
                      v-if="statusCreateTestInput === STATUS_PENDING"
                      :idTaskCreating="idTaskCreating"
                      @statusCreateTestInput="handleStatusCreateTestInput"
                      :countTime="countTime"
                    />
                    <succes-create-entrance-input
                      v-if="statusCreateTestInput === STATUS_TO_DO"
                      :idTaskCreating="createdTestInputScheduleId || successCreateData?.test_input_schedule_id || idTaskCreating"
                      :customerId="idCustomer || customer_id"
                      :successCreateData="successCreateData"
                    />
                    <cancel-create-input v-if="statusCreateTestInput === STATUS_FAlURE" />
                    <overload-create-test-input v-if="statusCreateTestInput === STATUS_OVER_LOADING" />
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4" v-if=checkEdit>
          <div class="card card-custom gutter-b example example-compact border border-info mb-3"
               v-if="filterOption.result.length > 0">
            <div class="card-header bg-info">
              <h3 class="card-title text-white">Kết quả tư vấn</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3" v-if="filterOption.result.includes('result')">
                  <div class="form-group">
                    <label class="form-label">Kết quả</label>
                    <input v-if="customer.ket_qua_tu_van == '1'" disabled type="text" class="form-control is-valid"
                           placeholder="Họ tên" value="Khách hàng đã đăng ký">
                    <input v-else-if="customer.ket_qua_tu_van == '0'" disabled type="text"
                           class="form-control is-invalid" placeholder="Họ tên" value="Khách hàng không đăng ký">
                    <input v-else disabled type="text" class="form-control is-invalid" placeholder="Họ tên"
                           value="Khách hàng chưa được tư vấn">
                  </div>
                </div>
                <div class="col-md-12 mb-3" v-if="customer.ket_qua_tu_van == '1' && filterOption.result.includes('course_register')">
                  <div class="form-group">
                    <label class="form-label">Khóa học muốn đăng ký</label>
                    <input disabled type="text" class="form-control" placeholder="Lý do"
                           v-model="customer.khoa_hoc_muon_dang_ky">
                  </div>
                </div>
                <div class="col-md-12 mb-3" v-if="filterOption.result.includes('reason')">
                  <div class="form-group">
                    <label class="form-label">Lý do</label>
                    <input disabled type="text" class="form-control" placeholder="Lý do"
                           v-model="customer.nguyen_nhan_khong_dang_ky">
                  </div>
                </div>
                <div class="col-md-6 mb-3" v-if="filterOption.result.includes('consultant')">
                  <div class="form-group">
                    <label class="form-label">Tư vấn viên</label>
                    <input disabled type="text" class="form-control" placeholder="Tư vấn viên"
                           v-model="customer.tu_van_vien">
                  </div>
                </div>
                <div class="col-md-6" v-if="filterOption.result.includes('consultant_phone')">
                  <div class="form-group">
                    <label class="form-label">SĐT tư vấn viên</label>
                    <input disabled type="text" class="form-control" placeholder="SĐT tư vấn viên"
                           v-model="customer.sdt_tvv">
                  </div>
                </div>
                <div class="col-md-12 mb-3" v-if="filterOption.result.includes('score')">
                  <div class="form-group">
                    <label class="form-label">Điểm test</label>
                    <input disabled type="text" class="form-control" placeholder="Điểm test"
                           v-model="customer.diem_test">
                  </div>
                </div>
                <div class="col-md-12 mb-3" v-if="filterOption.result.includes('comment')">
                  <div class="form-group">
                    <label class="form-label">Nhận xét</label>
                    <input disabled type="text" class="form-control" placeholder="Nhận xét"
                           v-model="customer.nhan_xet_dau_vao">
                  </div>
                </div>
                <div class="col-md-12 mb-3" v-if="filterOption.result.includes('hotkey_extra')">
                  <div class="form-group">
                    <label class="form-label">Phím nóng bổ sung</label>
                    <textarea class="form-control" rows="3" disabled v-model="customer.phim_nong_bo_sung"></textarea>
                  </div>
                </div>
                <div class="col-md-6 mb-3" v-if="filterOption.result.includes('financial_extra')">
                  <div class="form-group">
                    <label class="form-label">Tài chính bổ sung {{typeof customer.dieu_kien_tai_chinh_bo_sung}}</label>
                    <money  v-bind="money" class="form-control"
                            v-model="customer.dieu_kien_tai_chinh_bo_sung"></money>
                  </div>
                </div>
                <div class="col-md-6" v-if="filterOption.result.includes('decision_extra')">
                  <div class="form-group">
                    <label class="form-label">Người ra quyết định</label>
                    <el-select v-model="customer.nguoi_ra_quyet_dinh_bo_sung" clearable class="w-100"
                               placeholder="Người ra quyết định" disabled>
                      <el-option
                          v-for="item in nguoi_ra_quyet_dinh"
                          :key="item.id"
                          :label="item.value"
                          :value="item.id">
                        <span style="float: left">{{ item.value }}</span>
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="col-md-12" v-if="filterOption.result.includes('problem')">
                  <div class="form-group">
                    <label class="form-label">Vấn đề khách hàng sau tư vấn
                      <span class="text-danger"></span></label>
                    <textarea class="form-control" rows="3" disabled
                              v-model="customer.khach_hang_van_dang_con_van_de"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div v-if="filterOption.result.includes('list_contract')">
                <hr style="margin-top: 20px;">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="form-group form-label">DANH SÁCH HỢP ĐỒNG</h4>
                  </div>
                </div>
                <div v-if="customer && customer?.list_contract?.length">
                  <div class="row" v-for="item in customer.list_contract" style="margin-top: 10px;">
                    <div class="col-md-12">
                      <a style="font-size: 14px; color: #7453a6; text-decoration: underline !important; cursor: pointer; margin-top: 15px;" @click="handleViewContract(item)" >
                        Hợp đồng {{ customer.user.name }} - {{ item.created_at_format }}</a>
                    </div>
                  </div>
                </div>
                <div v-else style="font-style: italic; margin-top: 5px;">
                  <span>Chưa có hợp đồng!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row save-customer fixed-bottom bg-white border-top">
        <div class="col-12 d-flex justify-content-center py-2">
          <button class="btn btn-primary ml-3" type="submit">
            <i v-if="check_loading" class="el-icon-loading"></i>
            {{ showSaveWithSchedule ? 'Lưu và đặt lịch' : 'Lưu' }}
          </button>
          <button
              type="button"
              v-if="check_edit && checkDestroy"
              class="btn btn-danger ml-3"
              @click="destroyCustomer()"
          >
            <i v-if="check_loading_destroy" class="el-icon-loading"></i>
            Hủy data
          </button>
        </div>
      </div>
    </form>
    <el-dialog :title="dialog.title" class="responsive" :visible.sync="dialogFormVisible">
      <el-row :gutter="10" class="pr-2 pl-2">
        <contract-form
            v-if="dialogFormVisible"
            :customer-id="customer.id"
            :center-id="contract.center_id"
            :branch-id="contract.branch_id"
            :contract="contract"
            :check-edit="checkEdit"
            :check-view="checkView"
            @close="closeDialog">
        </contract-form>
      </el-row>
    </el-dialog>
    <el-dialog @closed="closeAndClearInfor" title="Thông báo" :visible.sync="dialogCompleteDebtOr30days" width="30%">
      <div style="word-break: break-word;">
        <p v-if="(isReRegister.completeDeblt && isReRegister.contract30days) || (isReRegister.completeDeblt && !isReRegister.contract30days)">Khách hàng này thuộc nguồn tái đăng ký nhưng chưa thể tạo do chưa hoàn thành hết công nợ của hợp đồng cũ.</p>
        <p v-else>Khách hàng này thuộc nguồn tái đăng ký nhưng chưa thể tạo do chưa đủ thời hạn tối thiểu để tái đăng ký: 03 tháng kể từ khi lên hợp đồng.</p>

      </div>
      <div class="d-flex justify-content-end">
        <el-button @click="closeAndClearInfor">Đã hiểu</el-button>
      </div>
    </el-dialog>

    <el-dialog top="5vh" style="z-index: 10000000;" class="dialogSetting" :visible.sync="dialogFilterForm" width="80%">
      <FiterForm
          v-model="filterOption"
          :initialSelected="filterOption"
          :is_show="dialogFilterForm"
          :idConfig="idConfig"
          @close="dialogFilterForm=false"
          @apply="onFieldSettingChange"/>
    </el-dialog>

  </ValidationObserver>
</template>
<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {Money} from 'v-money'
import FiterForm from "./components/FiterFormCreateCustomer.vue";
import {
  CUSTOMER_CREATE, CUSTOMER_DESTROY,
  CUSTOMER_FIND,
  CUSTOMER_UPDATE,
  CUSTOMER_FIND_RE_REGISTER,
  CHECK_PERSONAL_EDUTALK, GET_SCHOOL_LIST
} from "@/core/services/store/customer/customer.module";
import { GET_PROVINCES } from "../../../core/services/store/public/provinces.module";
import { GET_DISTRICTS } from "../../../core/services/store/public/districts.module";
import {mapGetters, mapState} from "vuex";
import ContractForm from "@/views/pages/customer/contract-form";
import DatLichTuVan from "@/views/pages/customer/dat-lich-tu-van";

import RescheduleTestInput from "@/views/pages/customer/reschedule-test-input.vue";
import LoadingCreateTestInput from "./components/LoadingCreateTestInput.vue";
import SuccesCreateInput from "./components/SuccesCreateInput.vue";
import SuccesCreateEntranceInput from "./components/SuccesCreateEntranceInput.vue";
import CancelCreateInput from "./components/CancelCreateInput.vue";
import OverloadCreateTestInput from "./components/OverloadCreateTestInput.vue";
import OptionCreateTestInput from "./components/OptionCreateTestInput.vue";
import ScheduleEntranceTestDialog from "./components/ScheduleEntranceTestDialog.vue";

import {
  CREATE_TEST_INPUT_SCHEDULE_CUSTOMER,
  STORE_ONLY_GENERAL,
  STORE_SPEAKING_API
} from "@/core/services/store/customer/testInput.module";
import {
  STATUS_CREATE,
  STATUS_FAlURE,
  STATUS_OVER_LOADING,
  STATUS_PENDING,
  STATUS_TO_DO
} from "@/core/config/testInput/testInputOption";
import {
  STATUS_CANCEL,
  STATUS_CHOOSE_OPTION, STATUS_NOT_ACTIVE,
  STATUS_ONLY_GENERAL,
  STATUS_SUCCESS,
  TYPE_SPEAKING_AI
} from "@/core/config/testInput/testInputOption";
import {SERVICE_CONFIG_CUSTOMER_GET} from "@/core/services/store/service.module";
import { extend } from 'vee-validate';

extend('different_phone', {
    params: ['target'],
    validate(value, { target }) {
        if (!value || !target) return true;
        return String(value) !== String(target);
    },
    message: 'Số điện thoại khác không được trùng với số điện thoại.',
});

const _ = require('lodash');
export default {
  components: {
    Money,
    ContractForm,
    FiterForm,
    DatLichTuVan,
    OptionCreateTestInput,
    ScheduleEntranceTestDialog,
    OverloadCreateTestInput,
    CancelCreateInput,
    SuccesCreateInput,
    SuccesCreateEntranceInput,
    LoadingCreateTestInput,
    RescheduleTestInput,
  },
  name: "CustomerForm",
  data() {
    return {
      customer: {
        list_contract: [],
        ngay_sinh:'',
        phim_nong: '',
        hot_key_detail: {},
        phone_other: '',
        co_quan: '',
        marking_exam_shift_id: null,
        center_entrance_id: null,
        province_id: '',
        district_id: '',
        sub_district: '',
      },
      pendingSpeakingAiCenterId: null,
      provinces: [],
      districts: [],
      is_show_room: false,
      check_loading: false,
      check_loading_destroy: false,
      check_edit: false,
      _birthdayBound: false,
      _birthdayInputEl: null,
      _birthdayLock: false,
      trangThaiTuVan: [
        {
          id: '',
          value: "--Chọn--"
        },
        {
          id: 0,
          value: "Khách hàng không đăng ký"
        },
        {
          id: 1,
          value: "Khách hàng đã đăng ký"
        },

      ],
      centers: [],
      yKien: [
        {id: '', value: "(Chọn ý kiến)"},
        {id: 'Chưa hỏi', value: 'Chưa hỏi'},
        {id: 'Đã hỏi - Không đồng ý', value: 'Đã hỏi - Không đồng ý'},
        {id: 'Đã hỏi - Đồng ý', value: 'Đã hỏi - Đồng ý'}
      ],
      nguon: [
        {id: '', value: "--Chọn--"},
        {id: 'Nhân', value: 'Nhân'},
        {id: 'Nội bộ', value: 'Nội bộ'},
        {id: 'Ấm nóng', value: 'Ấm nóng'},
        {id: 'Tiếp xúc lạnh', value: 'Tiếp xúc lạnh'},
        // {id: 'Tái đăng ký', value: 'Tái đăng ký'},
        {id: 'Liên kết trường', value: 'Liên kết trường'},
        {id: 'Lạnh', value: 'Lạnh'},
        {id: 'Facebook ads', value: 'Facebook ads'},
        {id: 'Google ads', value: 'Google ads'},
        {id: 'Tiktok ads', value: 'Tiktok ads'},
        {id: 'Vệ tinh', value: 'Vệ tinh'},
      ],
      nguoi_ra_quyet_dinh: [
        {id: '', value: "--Chọn--"},
        {id: 'Phụ huynh', value: "Phụ huynh"},
        {id: 'Bạn bè', value: "Bạn bè"},
        {id: 'Bản thân', value: "Bản thân"},
      ],
      trangThaiHen: [
        {id: 0, value: "Chưa có lịch hẹn"},
        {id: 1, value: "Có lịch hẹn"},
        {id: 2, value: "Delay hẹn"},
        {id: 3, value: "Hủy hẹn"},
        {id: 4, value: "Hủy data"},
      ],

      // Cache
      cacheLevel: [],
      cacheNguon: [],
      cacheYkien: [],
      cacheTrangThaiHen: [],
      cacheTrangThaiTuVan: [],
      customer_id : 0,
      cacheTrungTamHen: [],
      cacheNguoiRaQuyetDinh: [],
      money: {
        decimal: ',',
        thousands: ',',
        prefix: '',
        suffix: ' VNĐ',
        precision: 0,
        masked: false,
      },
      checkDestroy: false,
      dialogFormVisible: false,
      dialogScheduleAdvice: false,
      submitHotKeyDetail: false,
      appointment: {
        center_id: ''
      },
      dialog: {
        title: ''
      },
      phimNongDeFine: [
        {id: 1, value: "Tài chính", placeholder: "- Ai người quyết định chi trả tài chính?\n- Mức tài chính có phù hợp với gia đình không?\n- Mức tài chính có thể chi trả là bao nhiêu?"},
        {id: 2, value: "Phương pháp học", placeholder: "- Khách hàng lo ngại về hiệu quả phương pháp học?\n- Khách hàng cần thêm thông tin về phương pháp học?\n- Tại sao phải học tiếng anh?\n- Tại sao phải học tiếng Anh ở trung tâm này thay vì trung tâm khác?"},
        {id: 3, value: "Gia đình/Mối quan hệ", placeholder: "- Ai là người quyết định mua hàng?\n- Ai là người tác động, có tầm ảnh hưởng trong gia đình?\n- Khách hàng tin tưởng ai? (bạn bè, anh, chị, bố mẹ...)\n- Ý kiến phụ huynh?"},
        {id: 4, value: "Thời gian", placeholder: "- Khách hàng vướng lịch chưa học được? (VD: quân sự, chờ thi xong học, nghỉ hè...)\n- Tại sao phải học tiếng anh tại thời điểm này?"},
        {id: 5, value: "Định hướng học IELTS", placeholder: "- Khách hàng học IELTS để ra trường?\n- Khách hàng học IELTS để xin việc?\n- Kế hoạch ngắn hạn? dài hạn?"},
        {id: 6, value: "Quyết định và lựa chọn", placeholder: "- Khách hàng còn phân vân giữa các lựa chọn?\n- Tại sao chưa quyết định, cần thêm thuyết phục về điều gì?"},
        {id: 7, value: "Khoảng cách", placeholder: "- Khách hàng ở xa trung tâm? ...km?\n- Khách hàng lo lắng về vấn đề đi lại"},
        {id: 8, value: "Nỗi sợ", placeholder: "- Khách hàng không học được?\n- Sợ chi phí học cao?\n- Phân vân giữa học chứng chỉ/ngôn ngữ?"},
        {id: 9, value: "Khác", placeholder: "- Sở thích, Tính cách, Thói quen, Mong muốn"},
      ],
      objectCustomerDefine: [
        {id: 1, value: "Học sinh"},
        {id: 2, value: "Sinh viên"},
        {id: 3, value: "Người đi làm"},
      ],
      contract: null,
      checkEdit: false,
      is_personal: false,
      checkView: false,
      isScheduleAdvice: false,
      hasEntranceSchedule: false,
      check_re_register : false,
      check_clear : false,
      dialogCompleteDebtOr30days : false,
      dialogFilterForm: false,
      isReRegister : {
        completeDeblt : false,
        contract30days : false
      },
      filterOption: {
        basic: ['name','phone','email','facebook','birthday','que_quan','address','school','major', 'object_customer','province_id','district_id','sub_district'],
        parent: ['name','phone','origin','job','opinion'],
        potential: [
          'source','hotkey','solution','note'
        ],
        result: [
          'result','course_register','reason','consultant',
          'consultant_phone','score','comment','hotkey_extra',
          'financial_extra','decision_extra','problem','list_contract'
        ],
      },
      tableColumnsOption: {},
      testInput: null,
      STATUS_CHOOSE_OPTION: STATUS_CHOOSE_OPTION,
      STATUS_ONLY_GENERAL: STATUS_ONLY_GENERAL,
      STATUS_SPEAKING_AI: TYPE_SPEAKING_AI,
      statusCreateTestInput: STATUS_CHOOSE_OPTION,
      idTaskCreating : null,
      createdTestInputScheduleId: null,
      idCustomer: null,
      STATUS_TO_DO:STATUS_TO_DO,
      STATUS_PENDING:STATUS_PENDING,
      STATUS_FAlURE:STATUS_FAlURE,
      STATUS_OVER_LOADING:STATUS_OVER_LOADING,
      STATUS_CREATE:STATUS_CREATE,
      countTime : 60,
      successCreateData:{},
      idConfig: 0,
      schoolList: [],
      schoolLoading: false,
      schoolSearch: '',
      schoolPendingRequest: null,
      schoolPaging: {
        current_page: 0,
        last_page: 1,
        per_page: 20
      },
      schoolScrollEl: null,
      checkSchoolAffiliation: false

    }
  },
  beforeDestroy() {
    if (this._birthdayInputEl) {
        this._birthdayInputEl.removeEventListener('input', this.onBirthdayNativeInput)
    }
    this.removeSchoolScrollListener()
  },
  watch: {
    "customer.phone": function (val) {
      if(this.check_edit == false) {
        if(val.length >= 10) {
          this.searchPhone();
          this.checkPersonnelEdutalk();
        } else {
            this.is_personal = false
          if(this.check_clear && this.check_re_register) {
            this.clearReRegister();
          }
        }
      }
    }
  },
  async mounted() {
    this.getConfig();
    this.getSchoolList();
    this.getProvince();
    this.getDistricts();
    await this.$store.dispatch(SET_BREADCRUMB, [
        {title: "Khách hàng", route: "customer-list"},
        {title: "Tạo khách hàng", icon: 'fas fa-users'}
    ]);
    if (this.errors) {
      this.$refs.form.setErrors(this.errors);
    }
    if (this.$route.params.id !== undefined) {
      this.check_edit = true;
      this.fetchCustomer();
      this.$store.dispatch(SET_BREADCRUMB, [
        {title: "Khách hàng", route: "customer-list"},
        {title: "Sửa khách hàng", icon: 'fas fa-users'}
      ]);
    };

    if (this.currentUser.area > 0 && this.currentUser.account_type === 'GĐKV') {
      this.isGDKV = true;
      this.getCenter();
    } else {
      if (_.indexOf(['TPNS', 'TPOnline', 'TPTT'], this.currentUser?.account_type) > -1) {
        this.watchAs.unshift({
          id: 0,
          value: 'TPhòng/Giám đốc',
          label: 'TP/GĐ'
        });
      }
      this.statusCreateTestInput = this.isPilot? this.STATUS_CHOOSE_OPTION:this.STATUS_CREATE
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    ...mapGetters(['currentUser', 'isPilot', 'isPilotEntrance']),
    isRequireSchool() {
      // 1: Học sinh, 2: Sinh viên
      return [1, 2].includes(this.customer.object_customer);
    },
    showEntranceScheduleFlow() {
      return ![
        this.STATUS_PENDING,
        this.STATUS_TO_DO,
        this.STATUS_FAlURE,
        this.STATUS_OVER_LOADING
      ].includes(this.statusCreateTestInput);
    },
    showSaveWithSchedule() {
      return this.isScheduleAdvice || this.hasEntranceSchedule;
    }
  },
  methods: {
    goToTestInputDetail({ customerId, taskId, status, is_latest } = {}) {
      if (this.isPilotEntrance) {
        if (!taskId) return;
        const query = {};
        if (status != null) query.status = status;
        if (customerId) query.customer_id = customerId;
        if (is_latest === '1' || is_latest === '0') {
          query.is_latest = is_latest;
        }
        this.$router.push({
          name: 'customer-test-input-entrance',
          params: { id: taskId },
          query
        });
        return;
      }
      if (!customerId) return;
      this.$router.push({
        name: 'customer-test-input-schedule',
        params: { id: customerId },
        query: status != null ? { status } : {}
      });
    },
    resetEntranceScheduleFlow() {
      this.pendingSpeakingAiCenterId = null;
      this.customer.marking_exam_shift_id = null;
      this.customer.center_entrance_id = null;
      this.testInput = null;
      this.statusCreateTestInput = this.STATUS_CHOOSE_OPTION;
      this.hasEntranceSchedule = false;
    },
    handleEntranceScheduleChange(payload = {}) {
      const type = payload?.type || null;
      if (type === "basic") {
        this.pendingSpeakingAiCenterId = payload.center_id;
        this.customer.marking_exam_shift_id = null;
        this.customer.center_entrance_id = null;
        this.testInput = null;
        this.hasEntranceSchedule = true;
        this.statusCreateTestInput = this.STATUS_CHOOSE_OPTION;
        return;
      }
      if (type === "higher") {
        this.customer.marking_exam_shift_id = payload.marking_exam_shift_id;
        this.customer.center_entrance_id = payload.center_id;
        this.pendingSpeakingAiCenterId = null;
        this.testInput = null;
        this.hasEntranceSchedule = true;
        this.statusCreateTestInput = this.STATUS_CHOOSE_OPTION;
        return;
      }
      if (type === "mastery") {
        this.testInput = payload.testInput;
        this.pendingSpeakingAiCenterId = null;
        this.customer.marking_exam_shift_id = null;
        this.customer.center_entrance_id = null;
        this.hasEntranceSchedule = true;
        this.statusCreateTestInput = this.STATUS_CREATE;
        return;
      }
      // Incomplete / cleared → optional, không chặn lưu KH
      this.pendingSpeakingAiCenterId = null;
      this.customer.marking_exam_shift_id = null;
      this.customer.center_entrance_id = null;
      this.testInput = null;
      this.hasEntranceSchedule = false;
      this.statusCreateTestInput = this.STATUS_CHOOSE_OPTION;
    },
    getProvince() {
      this.$store
        .dispatch(GET_PROVINCES)
        .then((data) => {
          this.provinces = data.data;
        });
    },
    async getDistricts() {
      if (!this.customer.province_id) {
        this.districts = [];
        return;
      }
      await this.$store
        .dispatch(GET_DISTRICTS, {
          province_id: this.customer.province_id,
        })
        .then((data) => {
          this.districts = data.data;
        });
    },
    changeDistricts() {
      this.customer.district_id = '';
      this.getDistricts();
    },
    saveCustomer() {
      this.check_loading = true;
      let missingDetails = this.customer.hot_key.filter(
          id => !this.customer.hot_key_detail[id] || !this.customer.hot_key_detail[id].trim()
      );
      if (missingDetails.length > 0) {
        this.$notify({
          title: 'Thiếu dữ liệu!',
          message: 'Vui lòng nhập đầy đủ chi tiết cho các phím nóng đã chọn.',
          type: 'warning'
        });
        this.submitHotKeyDetail = true;
        this.check_loading = false;
        return;
      }

      //check khách hàng dưới 18 tuổi
      const birthday = this.$moment(this.customer.ngay_sinh, 'YYYY-MM-DD');
      const now = this.$moment();
      const age = now.diff(birthday, 'years');

      if (age < 18 && (!this.customer || !this.customer.bo_me) ) {
        this.$notify({
          title: 'Thiếu dữ liệu!',
          message: 'Khách hàng dưới 18 tuổi bắt buộc phải có thông tin họ tên, số điện thoại phụ huynh',
          type: 'warning'
        });
        this.check_loading = false;
        return;
      }

      if (this.check_edit) {
        this.$store.dispatch(CUSTOMER_UPDATE, this.customer).then((res) => {
          this.check_loading = false;
          if (!res.error) {
            this.$router.push({name: "customer-list"}).then(() => {
              this.$notify({
                title: 'Sửa khách hàng',
                message: 'Thành công',
                type: 'success'
              });
            })
          } else {
            this.$notify({
              title: 'Sửa khách hàng',
              message: res.message,
              type: 'error'
            });
          }
        }).catch((response) => {
          if (response?.data?.message) {
            this.$refs.form.setErrors(response.data.message);
          }
          this.$notify({
            title: 'Sửa khách hàng',
            message: 'Có lỗi xảy ra',
            type: 'error'
          });
          this.check_loading = false;
          return;
        });
      } else {
        this.$store.dispatch(CUSTOMER_CREATE, this.customer).then((res) => {
          this.check_loading = false;
          if (!res.error) {
            let handledNavigation = false;

            if (this.statusCreateTestInput === STATUS_CREATE && this.testInput) {
              this.$notify({
                title: 'Thêm khách hàng',
                message: res.message ?? 'Thành công',
                type: 'success'
              });
              this.createScheduleTestInput(res.data.id);
              handledNavigation = true;
            } else if (this.pendingSpeakingAiCenterId) {
              this.createSpeakingAiSchedule(res.data.id, this.pendingSpeakingAiCenterId);
              handledNavigation = true;
            }

            if (this.isScheduleAdvice) {
              // OLD: gán customer_id → DatLichTuVan watcher gọi datLichTuVan
              this.customer_id = res.data.id;
              if (!handledNavigation) {
                this.$notify({
                  title: 'Thêm khách hàng',
                  message: res.message ?? 'Thành công',
                  type: 'success'
                });
              }
            } else if (!handledNavigation) {
              this.$router.push({name: "customer-list"}).then(() => {
                this.$notify({
                  title: 'Thêm khách hàng',
                  message: res.message ?? 'Thành công',
                  type: 'success'
                });
                if (res?.entrance_exam_error) {
                  this.$nextTick(() => {
                    this.$notify({
                      title: 'Lỗi đăng ký thi đầu khóa',
                      message: res.entrance_exam_error,
                      type: 'error',
                      duration: 5000,
                    });
                  });
                }
              })
            }
          } else {
            this.$notify({
              title: 'Thêm khách hàng',
              message: res.message,
              type: 'error'
            });
          }
        }).catch((response) => {
          if (response?.data?.message) {
            this.$refs.form.setErrors(response.data.message);
          }
          this.$notify({
            title: 'Thêm khách hàng',
            message: 'Có lỗi xảy ra',
            type: 'error'
          });
          this.check_loading = false;

          return;
        });
      }
    },

    createScheduleTestInput(custormer_id) {
      if (this.statusCreateTestInput === STATUS_CHOOSE_OPTION) {
        return
      }
      let payload = this.testInput;
      payload.customer_id = custormer_id;
      this.isDisable = true;
      this.$store.dispatch(CREATE_TEST_INPUT_SCHEDULE_CUSTOMER, payload).then((data) => {
        setTimeout(() => {
          this.statusCreateTestInput = STATUS_PENDING;
        })
        this.idTaskCreating = data?.data?.id;
        this.createdTestInputScheduleId = data?.data?.test_input_schedule_id;
        // this.openScheduleTestInput = false;
      }).catch((error) => {
        this.$message({type: 'error', message: `${error.data.message}`, showClose: true});
        this.testInput.time = null;
        this.testInput.ngay_hen = null;
      }).finally(() => {
        // this.querySever();
        this.isDisable = false;
      })
    },
    createSpeakingAiSchedule(customerId, centerId) {
      const payload = {
        name: this.customer?.name,
        phone: this.customer?.phone,
        customer_id: customerId,
        center_id: centerId
      };
      this.statusCreateTestInput = this.STATUS_SPEAKING_AI;
      this.$notify({
        title: 'Thêm khách hàng',
        message: 'Thành công',
        type: 'success'
      });
      this.$store.dispatch(STORE_SPEAKING_API, payload).then((data) => {
        if (!data.data) {
          this.$message({
            message: 'Bạn đã chọn nhu cầu test đầu vào này trước đó. Vui lòng chọn hình thức khác.',
            type: 'warning'
          });
          this.$router.push({ name: 'customer-list' });
          return;
        }
        const testInputScheduleId = data?.data?.id;
        if (!testInputScheduleId || data?.error) {
          return;
        }
        this.goToTestInputDetail({
          customerId,
          taskId: testInputScheduleId,
          status: this.statusCreateTestInput,
          is_latest: '1'
        });
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error?.data?.message || 'Đặt lịch Speaking AI thất bại',
          showClose: true
        });
        this.$router.push({ name: 'customer-list' });
      });
    },
    fetchCustomer() {
      this.$store.dispatch(CUSTOMER_FIND, this.$route.params.id).then((res) => {
        this.customer = res.data;
        this.customer.hot_key = JSON.parse(this.customer.hot_key) ?? [];
        this.customer.hot_key_detail = JSON.parse(this.customer.hot_key_detail) ?? [];
        this.customer.ngay_sinh = (this.customer.ngay_sinh == '0000-00-00' || !this.customer.ngay_sinh) ?  '':  this.customer.ngay_sinh
        this.syncSelectedSchoolOption(this.customer.truong_hoc)
        if (this.customer.province_id) {
          this.getDistricts();
        }
        if (parseInt(res.data.level) < 3) {
          this.checkDestroy = true;
        } else {
          this.checkDestroy = false;
        }
      });
    },
    onFieldSettingChange(updatedSetting) {
      this.filterOption = updatedSetting;
    },
    onSubmit() {

    },
    destroyCustomer() {
      this.$store.dispatch(CUSTOMER_DESTROY, {id: this.customer.id}).then((res) => {
        this.check_loading_destroy = false;
        if (!res.error) {
          this.$router.push({name: "customer-list"}).then(() => {
            this.$notify({
              title: 'Hủy khách hàng',
              message: 'Thành công',
              type: 'success'
            });
          })
        } else {
          this.$notify({
            title: 'Hủy khách hàng',
            message: res.message,
            type: 'error'
          });
        }
      }).catch((response) => {
        this.$notify({
          title: 'Hủy khách hàng',
          message: 'Có lỗi xảy ra',
          type: 'error'
        });
        this.check_loading_destroy = false;
        return;
      });
    },
    handleViewContract(contract) {
      this.dialog.title = 'Chi tiết hợp đồng';
      this.dialogFormVisible = true;
      this.checkEdit = false;
      this.checkView = true;
      this.contract = contract;
    },
    closeDialog() {
      this.dialog = false;
    },
    searchPhone: _.debounce(function () {
      this.checkReRegister();
    }, 300),
    checkReRegister(){
      this.$store.dispatch(CUSTOMER_FIND_RE_REGISTER, {phone:this.customer.phone}).then((res) => {
        if(res.data) {
          this.check_re_register = true;
          this.check_clear = true;
          this.customer.name = res.data.name;
          this.customer.email = res.data.email;
          this.customer.ngay_sinh = res.data.profile.birthday;
          let check_complete_dept = res.data.check_contract.check_complete_dept;
          let check_30days = res.data.check_contract.check_30days;
          if( !check_complete_dept || !check_30days) {
            this.dialogCompleteDebtOr30days = true;
            this.isReRegister = {
              completeDeblt : !check_complete_dept ? true : false,
              contract30days : !check_30days ? true : false
            }
          }
          this.customer.sdt_phu_huynh = res.data.parent.phone ?? '';
          this.customer.phone_other = res.data.parent.phone_other ?? '';
          this.customer.bo_me = res.data.parent.name ?? '';
        } else {
          if(this.check_re_register) {
            this.customer.name = '';
            this.customer.email = '';
            this.customer.ngay_sinh = '';
          }
          this.check_re_register = false;
        }
      });
    },
    clearReRegister(){
      this.check_re_register = false;
      this.customer.name = '';
      this.customer.email = '';
      this.customer.ngay_sinh = '';
    },
    closeAndClearInfor(){
      this.dialogCompleteDebtOr30days = false;
      this.clearReRegister();
      this.customer.phone = '';
    },
    closePopup() {
      this.dialogScheduleAdvice = false
    },
    handleScheduleAdvice(value) {
      this.isScheduleAdvice = value;
    },
    handleScheduleAdviceCompleted(item) {
      if (!item) {
        return;
      }
      this.$router.push({ name: "customer-list" }).then(() => {
        this.$notify({
          title: 'Thêm khách hàng',
          message: 'Thành công',
          type: 'success'
        });
      });
    },

    confirmOption(isOnlyGeneral,centerId = undefined, registerType = null, optionPayload = {}){
      if(isOnlyGeneral){
        this.openScheduleTestInput = false;
        let payload = {
          name: this.customer?.name,
          phone: this.customer?.phone,
          customer_id: this.customer_id,
          center_id: centerId,
          ...optionPayload
        }
        let url = '';
        switch (isOnlyGeneral) {
          case 1:
            url = STORE_SPEAKING_API;
            this.statusCreateTestInput = this.STATUS_SPEAKING_AI;
            break;
          case 2:
            url = STORE_ONLY_GENERAL;
            break;
        }

        this.$store.dispatch(url,payload).then((data)=>{
          if (!data.data && isOnlyGeneral == 1)
          {
            this.$message({
              message: 'Bạn đã chọn nhu cầu test đầu vào này trước đó. Vui lòng chọn hình thức khác.',
              type: 'warning'
            });
            return;

          }
          const testInputScheduleId = data?.data?.id;
          if (!testInputScheduleId || data?.error) {
            return;
          }
          this.goToTestInputDetail({
            customerId: this.customer_id,
            taskId: testInputScheduleId,
            status: this.statusCreateTestInput,
            is_latest: '1'
          });
        });
        return;
      }
      this.statusCreateTestInput = this.STATUS_CREATE;
    },

    handleInfoTestInput(item) {
      this.testInput = item;
      this.testInput.customer_id = this.idCustomerSelected
    },

    handleStatusCreateTestInput(status,customerId,dataResponse){
      this.idCustomer = customerId;
      this.successCreateData = dataResponse;
      this.$router.push({name: "customer-list"}).then(() => {
        this.$notify({
          title: 'Đặt lịch test đầu vào',
          message: status == STATUS_TO_DO ? 'Thành công' : 'Thất bại',
          type: status == STATUS_TO_DO ? 'success' : 'error'
        });
      });
      setTimeout(()=>{
        this.statusCreateTestInput = status;
      })
    },

    getConfig() {
      this.checkEdit =  this.$route.path.includes('customer/edit') ? true : false;
      this.$store.dispatch(SERVICE_CONFIG_CUSTOMER_GET, {config_type: '0,', model: 'customer'})
          .then((res) => {
            if(res.data[0]) {
              this.idConfig =res.data.id ?? 0;
              this.filterOption = res.data[0];
            }
          })
      if(!this.checkEdit) {
        this.filterOption.result = [];
      }
    },

    getHotKeyLabel(id) {
      const item = this.phimNongDeFine.find(i => i.id === id);
      return item ? item.value : '';
    },

    getHotKeyPlaceholder(id) {
      const item = this.phimNongDeFine.find(i => i.id === id);
      return item ? item.placeholder : '';
    },

      bindBirthdayMask() {
          if (this._birthdayBound) return

          this.$nextTick(() => {
              const dp = this.$refs.birthdayPicker
              const input = dp?.$el?.querySelector('input')
              if (!input) return

              this._birthdayInputEl = input
              input.setAttribute('inputmode', 'numeric')
              input.setAttribute('maxlength', '10')
              input.setAttribute('autocomplete', 'off')

              input.addEventListener('input', this.onBirthdayNativeInput)
              this._birthdayBound = true
          })
      },

      onBirthdayNativeInput(e) {
          if (this._birthdayLock) return

          const input = e.target
          const old = String(input.value || '')
          const caret = input.selectionStart || 0

          const digits = old.replace(/\D/g, '').slice(0, 8)
          const digitsBeforeCaret = old.slice(0, caret).replace(/\D/g, '').length

          let formatted = digits
          if (digits.length > 2) formatted = digits.slice(0, 2) + '/' + digits.slice(2)
          if (digits.length > 4) formatted = digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4)

          let newCaret = digitsBeforeCaret
          if (digitsBeforeCaret > 2) newCaret += 1
          if (digitsBeforeCaret > 4) newCaret += 1
          newCaret = Math.min(newCaret, formatted.length)

          this._birthdayLock = true
          input.value = formatted
          try { input.setSelectionRange(newCaret, newCaret) } catch (_) {}
          this._birthdayLock = false

          const dp = this.$refs.birthdayPicker
          if (digits.length !== 8) {
              if (dp && 'userInput' in dp) dp.userInput = formatted
              this.customer.ngay_sinh = ''
              return
          }

          const dd = digits.slice(0, 2)
          const mm = digits.slice(2, 4)
          const yyyy = digits.slice(4, 8)

          const d = new Date(+yyyy, +mm - 1, +dd)
          const ok = d.getFullYear() === +yyyy && (d.getMonth() + 1) === +mm && d.getDate() === +dd
          if (!ok) {
              if (dp && 'userInput' in dp) dp.userInput = formatted
              this.customer.ngay_sinh = ''
              return
          }

          this.customer.ngay_sinh = `${yyyy}-${mm}-${dd}`
      },

      checkPersonnelEdutalk() {
        this.$store.dispatch(CHECK_PERSONAL_EDUTALK, {phone: this.customer.phone}).then((res) => {
            let data = res.data;
            if(data) {
                this.is_personal = true;
                Object.assign(this.customer, {
                    phone: data.phone,
                    name: data.name,
                    email: data.email,
                });

                this.$notify({
                title: 'Lưu ý!',
                message: 'Số điện thoại là nhân sự công ty EduTalk!',
                type: 'warning'
                });
            }
        }).catch((e) => {
            this.$notify({
                title: 'Thất bại!',
                message: 'Có lỗi đã xảy ra!',
                type: 'error'
            });
        })
        },
      formatSchoolOption(item) {
          return {
              id: item.id,
              name: [item.name, item.district_name, item.province].filter(Boolean).join(' - ')
          }
      },
      syncSelectedSchoolOption(school) {
          if (!school || !school.id) {
              return
          }

          const selectedId = Number(school.id)
          this.customer.co_quan = selectedId

          const hasSelectedSchool = this.schoolList.some(item => String(item.id) === String(selectedId))
          if (!hasSelectedSchool) {
              this.schoolList.unshift(this.formatSchoolOption(school))
          }
      },
      searchSchoolList: _.debounce(function(keyword) {
          this.schoolSearch = keyword || ''
          this.getSchoolList({ page: 1, reset: true, name: this.schoolSearch })
      }, 300),
      clearSchoolSearch() {
          this.schoolSearch = ''
          this.getSchoolList({ page: 1, reset: true, name: '' })
      },
      handleSchoolSelectVisible(visible) {
          if (visible) {
              this.$nextTick(this.addSchoolScrollListener)
          } else {
              this.removeSchoolScrollListener()
          }
      },
      addSchoolScrollListener() {
          this.removeSchoolScrollListener()
          this.schoolScrollEl = document.querySelector('.customer-school-select-dropdown .el-select-dropdown__wrap')
          if (this.schoolScrollEl) {
              this.schoolScrollEl.addEventListener('scroll', this.handleSchoolScroll)
          }
      },
      removeSchoolScrollListener() {
          if (this.schoolScrollEl) {
              this.schoolScrollEl.removeEventListener('scroll', this.handleSchoolScroll)
              this.schoolScrollEl = null
          }
      },
      handleSchoolScroll(event) {
          const target = event.target
          const isNearBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 20
          if (isNearBottom) {
              this.loadMoreSchoolList()
          }
      },
      loadMoreSchoolList() {
          if (this.schoolLoading || this.schoolPaging.current_page >= this.schoolPaging.last_page) {
              return
          }
          this.getSchoolList({ page: this.schoolPaging.current_page + 1, name: this.schoolSearch })
      },
      getSchoolList({ page = 1, reset = false, name = this.schoolSearch } = {}) {
          const request = { page, reset, name: name || '' }
          if (this.schoolLoading) {
              this.schoolPendingRequest = request
              return
          }

          this.schoolLoading = true
          this.schoolPendingRequest = null
          this.$store.dispatch(GET_SCHOOL_LIST, {
              page: request.page,
              per_page: this.schoolPaging.per_page,
              name: request.name
          }).then(response => {
              const data = Array.isArray(response?.data) ? response.data : []
              const pagination = response?.pagination || {}
              const schools = data
                  .filter(school => Number(school.action) === 0)
                  .map(this.formatSchoolOption)

              this.schoolPaging = {
                  current_page: Number(pagination.current_page || request.page),
                  last_page: Number(pagination.last_page || request.page),
                  per_page: Number(pagination.per_page || this.schoolPaging.per_page)
              }

              if (request.reset) {
                  const selectedOption = this.schoolList.find(item => String(item.id) === String(this.customer.co_quan))
                  this.schoolList = schools
                  if (selectedOption && !this.schoolList.some(item => String(item.id) === String(selectedOption.id))) {
                      this.schoolList.unshift(selectedOption)
                  }
                  this.syncSelectedSchoolOption(this.customer.truong_hoc)
                  return
              }

              const existingIds = new Set(this.schoolList.map(item => String(item.id)))
              this.schoolList = this.schoolList.concat(schools.filter(item => !existingIds.has(String(item.id))))
          }).finally(() => {
              this.schoolLoading = false
              if (this.schoolPendingRequest) {
                  const pendingRequest = this.schoolPendingRequest
                  this.schoolPendingRequest = null
                  this.schoolSearch = pendingRequest.name
                  this.getSchoolList(pendingRequest)
              }
          })
      },
      changeSource()
      {
          this.checkSchoolAffiliation = this.customer.nguon == 'Liên kết trường';
      }
  }
}
</script>
<style>
#edutalkCustomerForm .mx-datepicker {
  width: 100% !important;
}

#edutalkCustomerForm .card-header {
  color: #C9F7F5 !important;
}

#edutalkCustomerForm .el-dialog__body {
  padding: 2px 20px;
}

#edutalkCustomerForm .entrance-fade-slide-enter-active,
#edutalkCustomerForm .entrance-fade-slide-leave-active {
  transition: opacity .2s ease, transform .2s ease;
}

#edutalkCustomerForm .entrance-fade-slide-enter,
#edutalkCustomerForm .entrance-fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
